// extracted by mini-css-extract-plugin
module.exports = {"root":"AllMemorabilia_root__XjE7x"};